import React, { useEffect, useState, useRef } from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap"

//i18n
import DefaultForm from "../../form/DefaultForm"

import SweetAlert from "react-bootstrap-sweetalert"

import { putConteudo } from "../../../services/conteudos"
import Carregando from "../../Carregando"

export default function ModalConteudos({ opened, setOpened, refresh, values, setConteudos, ...props }) {
    const formRef = useRef()

    const [form, setForm] = useState({
        // conteudo: { name: "conteudo", type: "text", label: "Conteúdo", placeholder: "Conteúdo", errorMessage: "Campo obrigatório", validate: { required: { value: true } }, size: { lg: 12, md: 12, sm: 12 } }
        conteudo: { name: "conteudo", type: "file", base64: true, label: "Conteúdo", placeholder: "Conteúdo", errorMessage: "Campo obrigatório", validate: { required: { value: true } }, size: { lg: 12, md: 12, sm: 12 } }
    })

    const [sweetAlert, setSweetAlert] = useState({
        show: false,
        title: "",
        text: "",
        confirmBtnBsStyle: "success",
        onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) }
    })

    const [loading, setLoading] = useState(false)
    const [loadingSubmit, setLoadingSubmit] = useState(false)

    useEffect(async () => {
        if (values) {
            let newJson = { ...form }
            Object.keys(newJson).forEach(key => {
                if (newJson[key].type != "multiselect")
                    newJson[key] = { ...newJson[key], value: values?.hasOwnProperty(key) ? values[key] : null }
            })
            //console.log("NEW JSON", newJson)

            delete newJson.senha

            setForm(() => newJson)
        }
    }, [opened, values])

    const handleSubmit = async (event, errors, val) => {
        try {
            setLoadingSubmit(() => true)

            console.log("{ handleSubmit }", errors, val)
            if (errors.length > 0) return

            let data = val

            // throw { message: "TEste" }
            let result = await putConteudo(values._id, data)

            if (refresh) refresh(result, "edit") // Passar usuario para componente pai

            setSweetAlert({ ...sweetAlert, show: true, title: "Sucesso!", text: `Conteudo ${values ? "atualizada" : "cadastrada"} com sucesso`, success: true, onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }); setOpened(false); } })
        } catch (error) {
            console.error("ModalEdicaoConteudos ERROR", error)

            setSweetAlert({ ...sweetAlert, show: true, title: "Ooops!", text: error.data || "Ocorreu um erro", success: false, error: true })
        } finally {
            setLoadingSubmit(() => false)
        }
    }

    return (
        <Modal size="md" isOpen={opened} toggle={() => { setOpened(!opened) }}>
            <ModalHeader toggle={() => { setOpened(!opened) }}>
                Atualizar Conteúdo - {values?.nome}
            </ModalHeader>
            <ModalBody>
                {loading ?
                    <Carregando /> :
                    <DefaultForm formRef={formRef} fields={form} handleSubmit={handleSubmit} buttonText="Confirmar" buttonSubmitDisabled={loadingSubmit} />
                }

                {sweetAlert.show && <SweetAlert {...sweetAlert}>{sweetAlert.text}</SweetAlert>}
            </ModalBody>
        </Modal>
    )
}